import CreateMessageModal, { CreateMessageModalHandle } from './CreateMessageModal'
import './CreateMessageModal.scss'

export type { CreateMessageModalHandle }
export default CreateMessageModal